export default "/images/vendor/flag-icons/flags/1x1/ph.svg?f171bffcc4d9d58ef70acfcc365e1c7b";